// import React, { useState, useEffect } from "react";
// import slide1 from '../Images/slider-1.jpg'
// import slide2 from '../Images/slider-2.jpg'
// import slide3 from '../Images/slider-3.jpg'
// import slide4 from '../Images/slider-4.jpg'
// import slide5 from '../Images/slider-5.jpg'
// import slide6 from '../Images/slider-6.jpg'
// import slide7 from '../Images/slider-7.jpg'
// import slide8 from '../Images/slider-8.jpg'

// import slide9 from '../Images/slider-9.jpg'
// import slide10 from '../Images/slider-10.jpg'
// import "./slider.css";


// const slides = [
//   { id: 1, title: "King Salman Park - 2 Mosque & Post Office", location: "Kingdom of Saudi Arabia", link: "projects/king_salman.html", bgImage: slide1 },
//   { id: 2, title: "The Island Project - The MGM, Bellagio & Aria Hotels", location: "United Arab Emirates", link: "projects/island_project.html", bgImage: slide2 },
//   { id: 3, title: "W Hotel and ALEF Residences, The Palm, Dubai", location: "United Arab Emirates", link: "projects/w_hotel.html", bgImage: slide3 },
//   { id: 4, title: "King Abdul Aziz Road (KAAR) – 2 Kempinski, 1 Taj & 1 Hilton Hotels", location: "Kingdom of Saudi Arabia", link: "projects/king_abdul.html", bgImage: slide4 },
//   { id: 5, title: "Avenues Riyadh - Hilton Hotel, Residential & Office Tower", location: "Kingdom of Saudi Arabia", link: "projects/avenue_riyadh.html", bgImage: slide5 },
//   { id: 6, title: "New Palace of Justice", location: "Kuwait", link: "projects/new_palace.html", bgImage: slide6},
//   { id: 7, title: "Sabah Al Salem Stadium", location: "Kuwait", link: "projects/sabah_al.html", bgImage: slide7},
//   { id: 8, title: "Retal Ritz Carlton Resort", location: "Kingdom of Saudi Arabia", link: "projects/retal_ritz.html", bgImage: slide8 },
//   { id: 9, title: "Yas w Hotel Refurbishment, Abu Dhabi", location: "United Arab Emirates", link: "projects/yes_w.html", bgImage: slide9},
 
// ];

// export default function HeroSlider() {
//   const [current, setCurrent] = useState(0);
//   const length = slides.length;

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setCurrent((prev) => (prev === length - 1 ? 0 : prev + 1));
//     }, 6000);
//     return () => clearTimeout(timer);
//   }, [current, length]);

//   const nextSlide = () => {
//     setCurrent(current === length - 1 ? 0 : current + 1);
//   };

//   const prevSlide = () => {
//     setCurrent(current === 0 ? length - 1 : current - 1);
//   };

//   if (!Array.isArray(slides) || slides.length <= 0) return null;

//   return (
//     <section className="hero-slider">
//       {slides.map((slide, index) => (
//         <div
//           className={index === current ? "slide active" : "slide"}
//           key={slide.id}
//           style={{ backgroundImage: `url(${slide.bgImage})` }}
//         >
//           {index === current && (
//             <div className="content">
//               <h1>{slide.title}</h1>
//               <p>{slide.location}</p>
//               <a href='#' className="btn-primary">View Project</a>
//             </div>
//           )}
//         </div>
//       ))}

//       <button className="prev" onClick={prevSlide} aria-label="Previous Slide">&#10094;</button>
//       <button className="next" onClick={nextSlide} aria-label="Next Slide">&#10095;</button>
//     </section>
//   );
// }


import React, { useState, useEffect } from "react";
import "./slider.css";

export default function HeroSlider() {
  const [slides, setSlides] = useState([]);   // 👈 dynamic slides
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(true);

  const length = slides.length;

  // ============================
  // 1️⃣ Fetch Dynamic Slides
  // ============================
  useEffect(() => {
    async function fetchSlides() {
      try {
        const res = await fetch("https://infosightapi.emedha.in/api/hero-sliders");
        const data = await res.json();

        // Convert API format to slider format
        const formatted = data.map((item) => ({
          id: item.id,
          title: item.title,
          location: item.location,
          link: "#",
          bgImage: item.image,       // 👈 using dynamic URL from API
        }));

        setSlides(formatted);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch slides:", error);
        setLoading(false);
      }
    }

    fetchSlides();
  }, []);

  // ============================
  // 2️⃣ Auto Slide Timer
  // ============================
  useEffect(() => {
    if (length === 0) return;

    const timer = setTimeout(() => {
      setCurrent((prev) => (prev === length - 1 ? 0 : prev + 1));
    }, 6000);

    return () => clearTimeout(timer);
  }, [current, length]);

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  if (loading) return <p style={{ textAlign: "center" }}>Loading...</p>;
  if (slides.length === 0) return <p style={{ textAlign: "center" }}>No slides found.</p>;

  return (
    <section className="hero-slider">
      {slides.map((slide, index) => (
        <div
          className={index === current ? "slide active" : "slide"}
          key={slide.id}
          style={{ backgroundImage: `url(${slide.bgImage})` }}
        >
          {index === current && (
            <div className="content">
              <h1>{slide.title}</h1>
              <p>{slide.location}</p>
              <a href="/project" className="btn-primary">View Project</a>
            </div>
          )}
        </div>
      ))}

      <button className="prev" onClick={prevSlide} aria-label="Previous Slide">&#10094;</button>
      <button className="next" onClick={nextSlide} aria-label="Next Slide">&#10095;</button>
    </section>
  );
}
